module.exports = __webpack_public_path__ + "static/media/grocery-alt.324218fd.jpg";